import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { AdminClavesSatClavesCuentaPage } from "@/features/admin-clave-sat-clave-cuenta/components/AdminClavesSatClavesCuentaPage";
import { clavesSatClavesCuentaQueryOptions } from "@/features/admin-clave-sat-clave-cuenta/hooks/use-clave-sat-clave-cuenta";

/**
 * Ruta `/admin/mapeos-clave-cuenta` · gestor del catálogo "clave
 * producto/servicio SAT → cuenta contable" (equivalente de dbo.Tag).
 * Paginado server-side (P42) · precarga la primera página + las cuentas
 * contables (Select del alta/edición).
 */
/** Prellenado del alta desde la bandeja «Solicitudes de catálogos» (clave SAT solicitada). */
export interface MapeosSearch {
  altaClaveSat?: string;
}

export const Route = createFileRoute("/_authed-tw/admin/mapeos-clave-cuenta")({
  // La clave SAT es numérica · el router la parsea como número si viene en la URL tal cual.
  validateSearch: (search: Record<string, unknown>): MapeosSearch => {
    const v = search.altaClaveSat;
    const texto = typeof v === "number" ? String(v) : typeof v === "string" ? v.trim() : "";
    return { altaClaveSat: texto || undefined };
  },
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminMapeosClaveCuenta])
      ? Promise.all([
      queryClient.ensureQueryData(clavesSatClavesCuentaQueryOptions({ page: 1, pageSize: 15 })),
      queryClient.ensureQueryData(cuentasQueryOptions),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminMapeosClaveCuenta]}>
      <AdminClavesSatClavesCuentaPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
